/* eslint-disable */
export function statusBarCheckoutTrigger() {
  return {
    type: 'navigator/STATUSBAR_CHECKOUT_TRIGGER',
  };
}
